import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import reducers from './reducers';
import sagas from './sagas';
import { companiesApi } from '../modules/companies/companies-api';
import { myStatsApi } from '../modules/my-stats/my-stats-api';
import { subscriptionApi } from '../modules/subscription/subscription-api';
import { usersApi } from '../modules/users/users-api';
import { onboardingApi } from '../modules/onboarding/onboarding-api';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { bindAppAuthStore } from '../modules/auth';

export const RESET_STORE = 'RESET_STORE';

// History
export const history = createBrowserHistory();

// Redux Middleware
const sagaMiddleware = createSagaMiddleware();
const middlewares = [
  sagaMiddleware,
  routerMiddleware(history),
  myStatsApi.middleware,
  subscriptionApi.middleware,
  usersApi.middleware,
  onboardingApi.middleware,
  companiesApi.middleware,
];

export const store = configureStore({
  reducer: reducers(history),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  preloadedState: {},
});

bindAppAuthStore(store);
sagaMiddleware.run(sagas);

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppStore = typeof store;

export type AppThunkConfig = {
  dispatch: AppDispatch;
  state: AppState;
};

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
